import { Box, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";

const titles = {
  assigntranslation: "Assign Translation",
  translate: "Translate",
  downloadcontestpaper: "Download Contest Paper",
};

export default function TranslationModulePlaceholder() {
  const { pathname } = useLocation();
  const key = pathname.slice(1);
  const title = titles[key] || "Task Translation";
  document.title = title;
  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h5">{title}</Typography>
      <Typography sx={{ mt: 2, color: "text.secondary" }}>
        Content coming soon.
      </Typography>
    </Box>
  );
}
